import { render, staticRenderFns } from "./tableAutoScroll.vue?vue&type=template&id=12ff5486&scoped=true&"
import script from "./tableAutoScroll.vue?vue&type=script&lang=js&"
export * from "./tableAutoScroll.vue?vue&type=script&lang=js&"
import style0 from "./tableAutoScroll.vue?vue&type=style&index=0&id=12ff5486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff5486",
  null
  
)

export default component.exports